import React from "react";

function SectionAdvantageQA() {
  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* Title section */}
      <div>
        {/* Advantages of Humanizing Text */}
        <h1 className="display-6">
          Advantages of using our Humanize AI Text Tool
        </h1>
      </div>

      {/* Description section */}
      <div>
        <h5 className="mt-4">Improves Readability:</h5>
        <p className="lead">
          It turns artificial intelligence (AI)-generated text that is robotic
          or unduly formal into more organic, human-like language that is easier
          to read and more interesting.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Enhances Emotional Tone:</h5>
        <p className="lead">
          It adds empathy, warmth, and personality to content, making it more
          relatable and emotionally resonant with human readers.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Boosts Trust & Authenticity:</h5>
        <p className="lead">
          Humanized content sounds less automated, helping build trust with
          audiences by making the text appear more genuine and credible.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Better Audience Connection:</h5>
        <p className="lead">
          Tailors language, tone, and expressions to specific audiences (e.g.,
          casual, professional, or conversational), increasing relevance and
          impact.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Reduces Detection by AI Checkers:</h5>
        <p className="lead">
          Aims for a 100% human score, it helps content avoid being flagged as AI-generated by detection
          tools, which can be important for SEO, academic, or marketing
          purposes.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Saves Time in Editing:</h5>
        <p className="lead">
          Automates the rewriting process that would otherwise take significant
          manual effort to make AI-generated content sound human.
        </p>
      </div>
    </div>
  );
}

export default SectionAdvantageQA;
